import React from "react";
import { useTranslation } from "react-i18next";

// Import types
import {
  CvMessage,
  CvMessageActor,
  UserInputType,
  UserMessageContent,
  AiMessageContent,
} from "../../types/cv-editor.types";

interface ChatMessageProps {
  message: CvMessage;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const { t } = useTranslation("cvEditor");
  const isUser = message.actor === CvMessageActor.USER;

  // This function safely renders the content based on the actor and content type
  const renderContent = () => {
    if (message.actor === CvMessageActor.AI) {
      // Type assertion to tell TypeScript this is AiMessageContent
      const content = message.content as AiMessageContent;
      return <p className="text-gray-800">{content.text}</p>;
    }

    if (isUser) {
      // Type assertion for UserMessageContent
      const content = message.content as UserMessageContent;
      switch (content.type) {
        case UserInputType.TEXT:
          return <p className="text-white">{content.originalText}</p>;
        case UserInputType.AUDIO:
          return (
            <div>
              <span className="text-xs block text-white font-semibold uppercase tracking-wider">
                {t("interview.audioResponseLabel")}
              </span>
              <p className="text-white italic mt-1">"{content.originalText}"</p>
            </div>
          );
        case UserInputType.SKIP:
          return <p className="text-white italic">{t("interview.skipped")}</p>;
        default:
          return null;
      }
    }
    return null;
  };

  return (
    <div className={`flex w-full ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        className={`px-4 py-2 rounded-2xl max-w-sm md:max-w-md shadow-md ${
          isUser
            ? "bg-[#0A1172] text-white rounded-br-none" // User bubble style
            : "bg-white text-gray-800 rounded-bl-none" // AI bubble style
        }`}
      >
        {renderContent()}
      </div>
    </div>
  );
};
